import { createColumnHelper } from "@tanstack/react-table";
import moment from "moment";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { renderUserName } from "../../../../../utils/helpers/user";
import { useCompanyDateFormat } from "../../../../../utils/hooks/company";

const columnHelper = createColumnHelper();

export const useColumns = () => {
	const { t } = useTranslation();
	const dateFormat = useCompanyDateFormat();

	return useMemo(() => {
		const formatDate = (value) => (value ? moment(value).format(dateFormat) : "");
		const renderEndDate = (date) => formatDate(date) || t("no-end");

		return [
			columnHelper.accessor("user", {
				header: t("user"),
				cell: (info) => renderUserName(info.getValue()),
			}),
			columnHelper.accessor("effect", {
				header: t("update-type"),
				cell: (info) => {
					switch (info.getValue()) {
						case "terminate":
							return t("working-shift-allocation-update-terminate");
						case "remove":
							return t("working-shift-allocation-update-remove");
						default:
							return "-";
					}
				},
			}),
			// terminate only changes the end date; remove drops the whole period
			columnHelper.display({
				id: "oldValue",
				header: t("old-value"),
				cell: ({ row }) => {
					const { effect, allocation } = row.original;
					switch (effect) {
						case "terminate":
							return renderEndDate(allocation.endEffectiveDate);
						case "remove":
							return `${formatDate(allocation.startEffectiveDate) || "-"} – ${renderEndDate(allocation.endEffectiveDate)}`;
						default:
							return "-";
					}
				},
			}),
			columnHelper.display({
				id: "newValue",
				header: t("new-value"),
				cell: ({ row }) => {
					const { effect, endEffectiveDate } = row.original;
					return effect === "terminate" ? renderEndDate(endEffectiveDate) : "-";
				},
			}),
		];
	}, [t, dateFormat]);
};
